import Cookies from 'js-cookie'
import { APP_TYPES } from '@/utils/constants'

// todo: unset stuff has not been called anywhere. Scope it out!
const account = {
  state: {
    token: Cookies.get('default_auth_token') || null,
    accountId: Cookies.get('accountId') || null,
    name: Cookies.get('name') || null,
    email: Cookies.get('email') || null,
    linkedExporters: localStorage.getItem('linkedExporters') || [],
    portal_access_roles: {},
    userId: Cookies.get('user_id') || null,
    moneyThumbBankIds: []
  },
  getters: {
    accountId: (state) => state.accountId,
    userId: (state) => state.userId,
    token: (state) => state.token,
    linkedExporters: (state) =>
      typeof state.linkedExporters === 'string'
        ? JSON.parse(state.linkedExporters)
        : state.linkedExporters,
    currentExporter: (state) => {
      const exporters =
        typeof state.linkedExporters === 'string'
          ? JSON.parse(state.linkedExporters)
          : state.linkedExporters
      return (
        exporters.find((exporter) => +exporter.link_id === +state.accountId) ||
        null
      )
    },
    hasPermission: (state) => (hasPermission) => {
      const exporters =
        typeof state.linkedExporters === 'string'
          ? JSON.parse(state.linkedExporters)
          : state.linkedExporters
      const exporter =
        exporters.find((exporter) => +exporter.link_id === +state.accountId) ||
        null
      return (
        exporter &&
        exporter.parent_user_permissions.access_roles.indexOf(hasPermission) >
          -1
      )
    },
    hasActionPermission: (state) => (entity, action) => {
      if (state.portal_access_roles) {
        if (entity in state.portal_access_roles) {
          return state.portal_access_roles[entity].actions.includes(action)
        }
      }
      return false
    },
    userData: (state) => ({
      id: state.userId || '',
      name: state.name || '',
      bid: state.accountId || ''
    }),
    name: (state) => state.name,
    email: (state) => state.email,
    getMoneyThumbBankIds: (state) => state.moneyThumbBankIds
  },
  mutations: {
    SET_USER: (state, data) => {
      state.userId = data
      Cookies.set('userId', data)
    },
    SET_ACCOUNT: (state, data) => {
      state.name = data.name
      state.linkedExporters = data.linked_users
      state.email = data.email
      Cookies.set('name', data.name)
      Cookies.set('email', data.email)
      localStorage.setItem('linkedExporters', JSON.stringify(data.linked_users))
    },
    SET_USER_ACCESS_ROLES: (state, data) => {
      state.portal_access_roles = data
    },
    SET_ACCOUNT_ID: (state, data) => {
      Cookies.set('accountId', data)
      state.accountId = data
    },
    SET_INVOICE_ID: (state, data) => {
      state.invoiceId = data
    },
    UNSET_ACCOUNT: (state) => {
      state.accountId = null
      state.name = null
      state.linkedExporters = []
      state.email = null
      state.userId = null
      localStorage.removeItem('linkedExporters')
      window.location.href = `${process.env.VUE_APP_DRIP_PORTAL_HOST}/logout?app=${APP_TYPES.PSCF}&callback=${window.location.pathname}`
    },
    SET_EMAIL: (state, data) => {
      state.email = data
    },
    UNSET_TOKEN: (state) => {
      state.token = null
      state.userId = null
    },
    SET_MONEY_THUMB_BANK_IDS: (state, data) => {
      state.moneyThumbBankIds = data
    }
  },
  actions: {
    setUserId({ commit }, data) {
      commit('SET_USER', data)
    },
    setAccount({ commit }, data) {
      commit('SET_ACCOUNT', data)
    },
    setUserAccessRoles({ commit }, data) {
      commit('SET_USER_ACCESS_ROLES', data)
    },
    setAccountId({ commit }, data) {
      commit('SET_ACCOUNT_ID', data)
    },
    setInvoiveId({ commit }, data) {
      commit('SET_INVOICE_ID', data)
    },
    unsetAccount({ commit }) {
      commit('UNSET_ACCOUNT')
    },
    setEmail({ commit }, data) {
      commit('SET_EMAIL', data)
    },
    unsetToken({ commit }) {
      commit('UNSET_TOKEN')
    },
    setMoneyThumBankIds({ commit }, data) {
      commit('SET_MONEY_THUMB_BANK_IDS', data)
    }
  }
}

export default account
